import {  Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, from} from "rxjs";
 
import {Subscription} from "rxjs"; 
import {delay, map} from 'rxjs/operators';
import * as moment from 'moment';
import { Socket } from 'ngx-socket-io';
import {AnalyticService} from '../shared/services/analytic.service'
import { NbDialogService, NbToastrService } from '@nebular/theme';
 
@Component({
  selector: 'app-expenses-page',
  templateUrl: './expenses-page.component.html',
  styleUrls: ['./expenses-page.component.scss']
})
export class ExpensesPageComponent implements OnInit, OnDestroy{

lSub$:any;
    items:any;
 
  loading:boolean = true;

  constructor(     private analyticService: AnalyticService  ){
  }
   
 
   ngOnInit() {  

    this.lSub$ = this.analyticService.getExpenses().subscribe((data) =>{
		this.items = data.expenses
			
		this.loading = false
	})
  
  }


 


   
 
   ngOnDestroy() {
   	if(this.lSub$){
		this.lSub$.unsubscribe()
	}
   }
 
   


}
